import _ from "lodash";

// Trailing slash matters: "/platform/" excludes bare /platform.
export const ALLOWED_PATH_PREFIXES = ["/platform/"];

export const EXCLUDED_PATH_PREFIXES = [
  "/platform/pam",
  "/platform/switch-organization",
  "/platform/tools",
];

const startsWithAny = (pathname, prefixes) =>
  _.some(prefixes, prefix => _.startsWith(pathname, prefix));

// Exclusion wins: a pathname under an allowed prefix is still off if it also
// matches an excluded prefix.
export const isUpcomingMeetingRouteAllowed = pathname => {
  if (_.isEmpty(pathname)) return false;
  if (!startsWithAny(pathname, ALLOWED_PATH_PREFIXES)) return false;
  if (startsWithAny(pathname, EXCLUDED_PATH_PREFIXES)) return false;
  return true;
};
